import React from "react";
const KalenderSatker = React.lazy(() => import('./KalenderSatker'));

// config belum didaftarkan ke router

export const kalenderSatkerConfig = [
    {
        path: '/apps/kalender-satker',
        element: <KalenderSatker />,
        roleAccess: ['CALENDAR_SATKER'],
    },
    {
        path: '/apps/kalender-satker/detailEvent/:id',
        element: <KalenderSatker />,
        roleAccess: ['CALENDAR_SATKER'],
    }
];